import React, { useEffect, useState } from "react";
import ApiServices from "../../services/apiServices";
import "./index.css";
import storage from "../../services/storage";
import { toast } from "react-toastify";
import { useLoad } from "../../context/Load";
import ForcaSenha from "../../Components/ForcaSenha";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router";
import Tabela from "../../Components/Tabela";
import { Box } from "@mui/material";
import { FaRegEdit } from "react-icons/fa";
import { BsFiletypeXlsx } from "react-icons/bs";
import moment from "moment";
import { PiInstagramLogoBold } from "react-icons/pi";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function ApuracaoFeed() {
  const navigate = useNavigate();
  const { load, setLoad } = useLoad();
  const [listarAcoes, setListarAcoes] = useState([]);
  const [arquivoFile, setArquivoFile] = useState(null);
  const [nomeArquivo, setNomeArquivo] = useState(null);
  const [filtroColuna, setFiltroColuna] = useState([]);
  const [meses, setMeses] = useState([]);
  const [selected, setSelected] = useState("PENDENTES");
  const [ano, setAno] = useState([]);
  const [performance, setPerformance] = useState({
    pesquisar: "",
    concessionariaId: "",
    cargoId: "",
    mes: "",
    ano: "",
  });

  const [listarConcessionarias, setListarConcessionarias] = useState([]);
  const [listaCargo, setListaCargo] = useState([]);
  const [paginacao, setPaginacao] = useState({
    pageIndex: 1,
    pageSize: 10,
  });

  async function fnListarApuracoes() {
    const parametros = {
      q: performance.pesquisar || "",
      page: paginacao.pageIndex || "1",
      pageSize: paginacao.pageSize || "",
      participanteCargoId: performance.cargoId || "",
      acaoId: performance.concessionariaId || "",
      mes: performance.mes || "",
      ano: performance.ano || "",
    };

    setLoad(true);
    try {
      const queryString = new URLSearchParams(parametros).toString();
      let response = await ApiServices.apiGet(`performance?${queryString}`);

      if (response.statusCode == 200) {
        // setListarAcoes({
        //   nomeParticipante:
        //   concessionaria:
        //   usuarioInstagram:
        //   videoUrl:
        //   campanhaHyundai
        // });
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnListarConcessionarias() {
    setLoad(true);
    try {
      let response = await ApiServices.apiGet("dealer/pra-performance");

      if (response.statusCode == 200) {
        setListarConcessionarias(response.data);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnListarCargos() {
    setLoad(true);
    try {
      let response = await ApiServices.apiGet("participante/cargo");

      if (response.statusCode == 200) {
        setListaCargo(response.data);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnListarMeses() {
    const parametros = {
      ano: performance.ano || "",
    };
    setLoad(true);
    try {
      const queryString = new URLSearchParams(parametros).toString();
      let response = await ApiServices.apiGet(`performance/mes?${queryString}`);

      if (response.statusCode == 200) {
        setMeses(response.data);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnListarAno() {
    setLoad(true);
    try {
      let response = await ApiServices.apiGet("performance/ano");

      if (response.statusCode == 200) {
        setAno(response.data);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    fnListarConcessionarias();
    fnListarCargos();
    fnListarMeses();
    fnListarAno();
  }, []);
  useEffect(() => {
    fnListarMeses();
  }, [performance.ano]);
  useEffect(() => {
    fnListarApuracoes();
  }, [paginacao.pageSize, paginacao.pageIndex, performance.pesquisar]);

  const [acoes, setAcoes] = useState([
    {
      id: 1,
      participante: {
        concessionaria: "Concessionária",
        userName: "123.456.789-00",
        instagram: "joaosilva",
        data: "2024-12-10T00:00:00.000Z",
        postagem: "https://via.placeholder.com/150",
        video: "https://www.youtube.com/embed/Ay85yfhlXR8?si=oPeBfb3F6GkvWE4v",
        campanhaHyundai: "#hyundaicampanha",
      },
      criterios: [
        { nome: "Qualidade do vídeo", valor: 3 },
        { nome: "Qualidade do áudio", valor: 4 },
        { nome: "Entendimento do produto", valor: 5 },
      ],
    },
    {
      id: 2,
      participante: {
        concessionaria: "Concessionária",
        userName: "987.654.321-00",
        instagram: "mariaoliveira",
        data: "2024-12-10T00:00:00.000Z",
        postagem: "https://via.placeholder.com/150",
        video: "https://www.youtube.com/embed/qookIkpE2Ic?si=BUFxjwtJ6LR3QqWZ",
        campanhaHyundai: "#hyundaicampanha2",
      },
      criterios: [
        { nome: "Qualidade do vídeo", valor: 2 },
        { nome: "Qualidade do áudio", valor: 3 },
        { nome: "Entendimento do produto", valor: 4 },
      ],
    },
    {
      id: 3,
      participante: {
        concessionaria: "Concessionária",
        userName: "111.222.333-44",
        instagram: "carlossouza",
        data: "2024-12-10T00:00:00.000Z",
        postagem: "https://via.placeholder.com/150",
        video: "https://www.youtube.com/embed/00X0uy45fRM?si=lmuBZvo_O1XIDIF-",
        campanhaHyundai: "#hyundaicampanha3",
      },
      criterios: [
        { nome: "Qualidade do vídeo", valor: 4 },
        { nome: "Qualidade do áudio", valor: 4 },
        { nome: "Entendimento do produto", valor: 5 },
      ],
    },
    {
      id: 4,
      participante: {
        concessionaria: "Concessionária",
        userName: "111.222.333-44",
        instagram: "carlossouza",
        data: "2024-12-10T00:00:00.000Z",
        postagem: "https://via.placeholder.com/150",
        video: "https://www.youtube.com/embed/00X0uy45fRM?si=lmuBZvo_O1XIDIF-",
        campanhaHyundai: "#hyundaicampanha3",
      },
      criterios: [
        { nome: "Qualidade do vídeo", valor: 4 },
        { nome: "Qualidade do áudio", valor: 4 },
        { nome: "Entendimento do produto", valor: 5 },
      ],
    },
  ]);
  const [avaliacoes, setAvaliacoes] = useState([]);

  useEffect(() => {
    fnListarAcoes();
  }, [performance]);

  const fnListarAcoes = async () => {
    try {
      const response = await ApiServices.apiGet(
        `performance/listar?mes=${performance.mes}&status=${performance.status}&pesquisar=${performance.pesquisar}`
      );
      if (response.statusCode === 200) {
        setAcoes(response.data);
      } else {
        toast.error("Erro ao carregar as ações");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPerformance((prev) => ({ ...prev, pesquisar: e.target.value }));
  };

  const handleStatusChange = (status) => {
    setPerformance((prev) => ({ ...prev, status }));
  };

  const handleRatingChange = (acaoIndex, criterioIndex, valor) => {
    const updatedAcoes = [...acoes];
    updatedAcoes[acaoIndex].criterios[criterioIndex].valor = valor;
    setAcoes(updatedAcoes);
  };

  const handleApproval = async (id, status) => {
    try {
      const response = await ApiServices.apiPost(`performance/${id}/status`, {
        status,
      });
      if (response.statusCode === 200) {
        toast.success("Status atualizado com sucesso!");
        fnListarAcoes();
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  return (
    <>
      <div className="row">
        <span className="tituloPagina">APURAÇÃO</span>

        <div className="row">
          <span className="mt-5">
            <strong>Filtros</strong>
          </span>
          <div className="col-md-2 mt-3">
            <label>Ano</label>
            <select
              className="form-select"
              value={performance.ano}
              onChange={(e) => {
                e.persist();
                setPerformance((prev) => ({
                  ...prev,
                  ano: e.target.value,
                }));
              }}
            >
              <option value="">Todos</option>
              {ano.map((e, i) => (
                <option key={i} value={e}>
                  {e}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-2 mt-3">
            <label>Mês</label>
            <select
              className="form-select"
              value={performance.mes}
              onChange={(e) => {
                e.persist();
                setPerformance((prev) => ({
                  ...prev,
                  mes: e.target.value,
                }));
              }}
            >
              <option value="">Todos</option>
              {meses.map((e, i) => (
                <option key={i} value={e.mesId}>
                  {e.descricao}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-2 mt-3">
            <label>Cargo</label>
            <select
              className="form-select"
              value={performance.cargoId}
              onChange={(e) => {
                e.persist();
                setPerformance((prev) => ({
                  ...prev,
                  cargoId: e.target.value,
                }));
              }}
            >
              <option value="">Todos</option>
              {listaCargo.map((e, i) => (
                <option key={i} value={e.participanteCargoId}>
                  {e.nome}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-2 mt-3">
            <label> </label>
            <button className="btn btn-primary " onClick={fnListarApuracoes}>
              Buscar
            </button>
          </div>
        </div>
      </div>
      <div className="row mt-5 w-100">
        <div className="d-flex">
          <div
            className={`status-item me-5 ${
              selected === "PENDENTES" ? "selected" : ""
            }`}
            onClick={() => setSelected("PENDENTES")}
          >
            Pendentes (79)
          </div>
          <div
            className={`status-item me-5 ${
              selected === "APROVADOS" ? "selected" : ""
            }`}
            onClick={() => setSelected("APROVADOS")}
          >
            Aprovados (0)
          </div>
          <div
            className={`status-item me-5 ${
              selected === "REPROVADOS" ? "selected" : ""
            }`}
            onClick={() => setSelected("REPROVADOS")}
          >
            Reprovados (4)
          </div>
          <div className="ms-auto">
            <TextField
              variant="outlined"
              placeholder="Pesquisar..."
              value={searchTerm}
              onChange={handleSearchChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              
            />
          </div>
        </div>
      </div>
      <div className="acoes-lista p-3">
        {acoes.map((acao, acaoIndex) => (
          <div key={acao.id} className="acao">
            <div className="participante-infos">
              <div className="participante">
                <div
                  className="d-flex justify-content-between mb-2"
                  style={{ borderBottom: "1px solid #8080804d" }}
                >
                  <p className="d-flex flex-column mb-2">
                    <strong>Nome do participante</strong>{" "}
                    {acao.participante.userName}
                  </p>
                  <p className="d-flex align-items-end mb-2">
                    {acao.participante.concessionaria}
                  </p>
                </div>
                <div className="d-flex">
                  <div className="me-3">
                    <img
                      src={acao.participante.postagem}
                      alt="Postagem do participante"
                    />
                  </div>
                  <div className="d-flex flex-column justify-content-center">
                    <p style={{ fontSize: "15px" }}>
                      <strong>@{acao.participante.instagram}</strong>
                    </p>
                    <p style={{ fontSize: "10px", color: "#808080" }}>
                      {moment(acao.participante.data).format("DD/MM/YYYY")}
                    </p>
                  </div>
                  <div className="ms-auto d-flex align-items-center">
                    <PiInstagramLogoBold style={{ fontSize: "50px" }} />
                  </div>
                </div>
              </div>
              <div>
                <iframe
                  width="560"
                  height="315"
                  src={acao.participante.video}
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
                <span style={{ fontSize: "12px" }}>
                  {acao.participante.campanhaHyundai}
                </span>
              </div>
            </div>
            <div className="acoes-fundo">
              <div className="avaliacao">
                <h5 className="mb-3">Avaliação</h5>
                {acao.criterios.map((criterio, criterioIndex) => (
                  <div key={criterio.nome}>
                    <label>{criterio.nome}</label>
                    <div className="stars">
                      {[...Array(5)].map((_, i) => (
                        <span
                          key={i}
                          className={`star ${
                            criterio.valor >= i + 1 ? "selected" : ""
                          }`}
                          onClick={() =>
                            handleRatingChange(acaoIndex, criterioIndex, i + 1)
                          }
                        >
                          ★
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              <div className="acoes-botoes">
                <button
                  className="btn btn-success"
                  onClick={() => handleApproval(acao.id, "APROVADO")}
                >
                  Concluir
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => handleApproval(acao.id, "REPROVADO")}
                >
                  Reprovar
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
